import {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'

import PropTypes from 'prop-types';

import {signOutUser} from "../actions/usuario";

class Logout extends Component {

    componentWillMount() {
        this.props.dispatch(signOutUser());
        this.props.history.replace('/');
    }

    render() {
        return null
    }
}

Logout.propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(connect()(Logout))


// WEBPACK FOOTER //
// src/components/Logout.js